module.exports = __webpack_public_path__ + "static/sport/bgi-h5.a37ee2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-h5.jpg
// module id = ugzP
// module chunks = 0